import React from 'react';

import { FormContainer, InputForm, Container } from './FormWrapper.styled';

type FormProps = {
  children: JSX.Element | JSX.Element[];
};

export const FormWrapper: React.FC<FormProps> = ({ children }: FormProps) => (
  <Container>
    <FormContainer>
      <InputForm>{children}</InputForm>
    </FormContainer>
  </Container>
);
